import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'utc-tooltip-anchor-content',
    templateUrl: './tooltipAnchorContent.component.html',
    styleUrls: ['./tooltipAnchorContent.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class TooltipAnchorContentComponent {}
